import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GenerateReportWizard from '../../../GenerateReport/AdminWizard/GenerateAdminReportWizard';
import './AnalyticsDashboardHeader.css';
import SessionsDateRangeSelector from '../../../Sessions/Filters/SessionsDateRangeSelector';
import RangeFilter from '../../../Sessions/Filters/SessionsRangeFilter';
import {
  ReportStatus,
  toggleGenerateReportModal as generateReportModalToggle
} from '../../../../Reducks/Reports/ReportsActions';
import { getAdminSessions, resetSessionCreators } from '../../../../Reducks/AdminSessions/AdminSessionsActions';
import { Route, Switch, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Notification from '../../../GenerateReport/Notification';
import { SESSIONS_OVERVIEW } from '../../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import OrganizerFilter from '../../Filters/OrganizerFilter';
import { getSessionCreators } from '../../../../Apis/ReportingReadApi';
import { CREATORS_PAGE_COUNT } from '../../../../Utils/Constants';

export class AnalyticsDashboardHeader extends Component {
  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    reduced_reports: PropTypes.object,
    toggleGenerateReportModal: PropTypes.func,
    match: PropTypes.object
  };

  render() {
    const { isBig } = this.props;
    const {
      match,
      toggleGenerateReportModal,
      reduced_reports,
      reduced_user,
      reduced_sessions,
      getSessions,
      getSessionCreators,
      resetCreators
    } = this.props;
    const { isGenerateReportOpen } = reduced_reports;
    return (
      <div className="adminAnalyticsDashboardHeader">
        <div className="analyticsDashboardHeaderButtons">
          {!isBig && (
            <Switch>
              <Route
                exact
                path={match.url + '/sessions'}
                render={props => (
                  <SessionsButtons
                    {...props}
                    reduced_sessions={reduced_sessions}
                    reduced_reports={reduced_reports}
                    reduced_user={reduced_user}
                    getSessions={getSessions}
                    getCreators={getSessionCreators}
                    resetCreators={resetCreators}
                    toggleGenerateReportModal={toggleGenerateReportModal}
                  />
                )}
              />
            </Switch>
          )}
        </div>
        <GenerateReportWizard toggle={toggleGenerateReportModal} isOpen={isGenerateReportOpen} isBig={isBig} />
      </div>
    );
  }
}

export const SessionsButtons = props => {
  const mixpanelData = {
    action: SESSIONS_OVERVIEW
  };
  const {
    reduced_sessions,
    getSessions,
    reduced_user,
    reduced_reports,
    toggleGenerateReportModal,
    getCreators,
    resetCreators
  } = props;

  const accountKey = reduced_user.user.accountKey;
  const { filter, creators, creatorsFetching } = reduced_sessions;
  const { reportFetchStatus } = reduced_reports;

  const getOrganizerFilterSessions = creators => {
    const { fromTime, toTime, registrantRange, attendeeRange } = filter;
    getSessions(accountKey, fromTime, toTime, creators, registrantRange, attendeeRange);
  };

  const getDateFilterSessions = (fromTime, toTime) => {
    const { creators, registrantRange, attendeeRange } = filter;
    getSessions(accountKey, fromTime, toTime, creators, registrantRange, attendeeRange);
    getCreators(accountKey, fromTime, toTime, 0, null, CREATORS_PAGE_COUNT, true);
  };

  const getFilteredSessionsByCount = filterOptions => {
    const { registrantRange, attendeeRange } = filterOptions;
    const { fromTime, toTime, creators } = filter;
    getSessions(accountKey, fromTime, toTime, creators, registrantRange, attendeeRange);
  };

  return (
    <React.Fragment>
      <OrganizerFilter
        isBig={false}
        uniqueId={'sessionsOrganizerFilterContainer'}
        creators={creators.creators}
        filteredCreators={filter.creators}
        accountKey={accountKey}
        getData={getOrganizerFilterSessions}
        getCreators={getCreators}
        resetCreators={resetCreators}
        creatorsFetching={creatorsFetching}
        fromTime={filter.fromTime}
        toTime={filter.toTime}
        nextPage={creators.nextPage}
        page={creators.page}
        mixpanelData={mixpanelData}
      />
      <RangeFilter
        uniqueId={'sessionsRangeFilterInDashboardHeader'}
        isBig={false}
        mixpanelData={mixpanelData}
        reduced_sessions={reduced_sessions}
        filterSessionsByCount={getFilteredSessionsByCount}
      />
      <SessionsDateRangeSelector
        uniqueId={'sessionsDateRangeSelectorInDashboardHeader'}
        mixpanelData={mixpanelData}
        isBig={false}
        reduced_sessions={reduced_sessions}
        getSessions={getDateFilterSessions}
      />
      {!reduced_user.entitlements.isRestrictReportDownloadEnabled && (
        <BuildReportButton
          toggleGenerateReportModal={toggleGenerateReportModal}
          disabled={reportFetchStatus === ReportStatus.FETCHING}
          isBig={false}
        />
      )}
    </React.Fragment>
  );
};

export const BuildReportButton = ({ toggleGenerateReportModal, isBig, disabled }, { t }) => {
  return (
    <div>
      {isBig ? (
        <Button
          id="createReportFromHeader"
          className={'button-dark-mode-override'}
          color="primary"
          disabled={disabled}
          onClick={toggleGenerateReportModal}>
          {t('buttons.buildReport')}
        </Button>
      ) : (
        <i
          className={`togo-icon togo-icon-file-txt mobileHeaderIcons ${disabled ? 'disabledIcons' : ''}`}
          onClick={() => !disabled && toggleGenerateReportModal()}
        />
      )}
      <Notification isBig={isBig} />
    </div>
  );
};
BuildReportButton.propTypes = {
  toggleGenerateReportModal: PropTypes.func,
  disabled: PropTypes.bool,
  isGenerateReportOpen: PropTypes.bool,
  isBig: PropTypes.bool
};
BuildReportButton.contextTypes = {
  t: PropTypes.func
};
export default withRouter(
  connect(
    state => ({
      reduced_reports: state.reduced_reports,
      reduced_user: state.reduced_user,
      reduced_sessions: state.reduced_admin_sessions
    }),
    {
      toggleGenerateReportModal: generateReportModalToggle,
      getSessions: getAdminSessions,
      getSessionCreators,
      resetCreators: resetSessionCreators
    }
  )(AnalyticsDashboardHeader)
);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Admin/AdminDashboard/Header/AnalyticsDashboardHeader.js